export interface Step {
  id: number;
  title: string;
  filled: boolean;
  select: boolean;
  disabled: boolean;
  link: string;
}

/**
 * Pasos del stepper superior. El paso "Pago" (con selector de método) solo
 * existe en el flujo con pasarela asignada — Mercado Pago o WeTravel según
 * la moneda de Turismo City (CAT-4903, generaliza CAT-4825 que era MP-only).
 * Sin pasarela asignada (otra moneda, o fuera de TC) es el motor normal de
 * 3 pasos con pago en efectivo/agencia.
 */
export function buildPaymentSteps(
  hasGatewayFlow: boolean,
  isMobile: boolean
): Step[] {
  if (hasGatewayFlow) {
    return [
      {
        id: 1,
        title: 'Listado de resultados',
        filled: true,
        select: true,
        disabled: false,
        link: '/results',
      },
      {
        id: 2,
        title: 'Datos del pasajeros',
        filled: false,
        select: false,
        disabled: true,
        link: '/booking-payments',
      },
      {
        id: 3,
        title: 'Pago',
        filled: false,
        select: false,
        disabled: true,
        link: '/booking-payments',
      },
      {
        id: 4,
        title: 'Confirmación de reserva',
        filled: false,
        select: false,
        disabled: true,
        link: '/confirmation',
      },
    ];
  }
  return [
    {
      id: 1,
      title: 'Listado de resultados',
      filled: true,
      select: true,
      disabled: false,
      link: '/results',
    },
    {
      id: 2,
      title: 'Datos del pasajero',
      filled: false,
      select: false,
      disabled: true,
      link: '/booking-payments',
    },
    {
      id: 3,
      title: isMobile ? 'Confirmación de reserva' : 'Confirmación',
      filled: false,
      select: false,
      disabled: true,
      link: '/confirmation',
    },
  ];
}
